import { Avatar, Button, Divider, Stack, Typography } from '@mui/material';
import { IEntitlement } from 'API/compassRights';
import { ButtonsBackground } from 'Components/ButtonsBackground';
import { OneOrTwoButtons } from 'Components/OneOrTwoButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  ArrowBackBlue,
  EmploymentIcon,
  FromHeart,
  LeftArrow,
  SocialHelp,
  Statoscope,
  UploadPrescription,
} from 'Images';
import { useNavigate } from 'react-router-dom';

export const Card = ({
  entitlementTypeId,
  name,
  description,
  additionalInfoText,
  additionalInfoLink,
  actionButtonText,
  actionButtonLink,
}: IEntitlement) => {
  const navigate = useNavigate();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userRights;
  const isDesktop = useIsDesktop();

  const mobileIcons: { [index: number]: { img: string } } = {
    1: { img: FromHeart },
    2: { img: Statoscope },
    3: { img: SocialHelp },
    4: { img: EmploymentIcon },
  };

  return (
    <Stack
      sx={{
        boxShadow: '-2px -2px 10px 0px rgba(8, 30, 84, 0.04)',
        backgroundColor: 'primary.shade_50',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '16px',
        justifyContent: 'space-between',
        pt: isDesktop ? '20px' : 0,
        position: 'relative',
        maxWidth: isDesktop ? '366px' : undefined,
      }}
    >
      <Stack flexDirection={'row'}>
        <Stack sx={{ overflow: 'hidden' }}>
          <Typography
            variant={isDesktop ? 'body1' : 'body2'}
            sx={{
              p: isDesktop ? '16px 24px 0px' : '16px 24px 8px 24px',
            }}
            component={'h3'}
          >
            {name}
          </Typography>
          <Typography
            component={'p'}
            variant={isDesktop ? 'body6' : 'body3'}
            sx={{
              p: isDesktop ? '24px 24px 32px' : '0px 24px 24px',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxHeight: isDesktop ? '115px' : '100px',
              mb: '20px',
            }}
          >
            {description}
          </Typography>
        </Stack>
      </Stack>
      <Stack>
        <OneOrTwoButtons
          rightButton={
            !!additionalInfoText
              ? {
                  label: additionalInfoText || '',
                  icon: UploadPrescription,
                  onClick: () => {
                    if (!!additionalInfoLink)
                      window.open(additionalInfoLink, '_blank');
                  },
                }
              : undefined
          }
          leftButton={
            !!actionButtonText
              ? {
                  label: actionButtonText || '',
                  icon: ArrowBackBlue,
                  onClick: () => {
                    if (actionButtonLink) navigate(actionButtonLink);
                  },
                }
              : undefined
          }
          width={'100%'}
          cardVariant
        />
      </Stack>
    </Stack>
  );
};
